/* ECOSAC THEME — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Header height para cart drawer ── */
  function setHeaderHeight() {
    var h = document.getElementById('site-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  /* ── Mobile menu ──
     REMOVIDO: a lógica de abrir/fechar o menu mobile (hambúrguer,
     drawer, overlay) já vive inteiramente dentro de header.liquid,
     que usa #mobile-menu-toggle, #mobile-menu-dropdown e
     #mobile-menu-overlay. Esse bloco antigo procurava .mobile-menu,
     .mobile-menu__close e #overlay — elementos que não existem mais
     no HTML atual — mas ainda assim registrava um SEGUNDO listener
     de clique no mesmo botão .header__mobile-toggle, brigando com
     o listener correto e deixando o overlay/scroll em estado
     inconsistente. Não duplicar essa lógica em dois arquivos. */

  /* ── [data-open-cart] → delega para DrinkinCart quando disponível ── */
  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.DrinkinCart) {
        window.DrinkinCart.open();
      }
    });
  });

  /* ── Slideshow ── */
  document.querySelectorAll('.slideshow').forEach(function (ss) {
    var slides  = ss.querySelectorAll('.slideshow__slide');
    var dots    = ss.querySelectorAll('.slideshow__dot');
    var current = 0;
    if (!slides.length) return;

    function goTo(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    var prev = ss.querySelector('.slideshow__prev');
    var next = ss.querySelector('.slideshow__next');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    if (slides.length > 1) setInterval(function () { goTo(current + 1); }, 5000);
  });

  /* ── Category circles nav ── */
  document.querySelectorAll('.category-circles__wrapper').forEach(function (wrap) {
    var grid = wrap.querySelector('.category-circles__grid');
    var prev = wrap.querySelector('.circles-nav-btn--prev');
    var next = wrap.querySelector('.circles-nav-btn--next');
    if (prev) prev.addEventListener('click', function () { grid.scrollBy({ left: -240, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { grid.scrollBy({ left:  240, behavior: 'smooth' }); });
  });

  /* ── Generic sliders ── */
  document.querySelectorAll('.slider-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.slider-track');
    var prev  = wrap.querySelector('.slider-btn--prev');
    var next  = wrap.querySelector('.slider-btn--next');
    if (!track) return;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -220, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left:  220, behavior: 'smooth' }); });
  });

  /* ── Most sold inner slider ── */
  document.querySelectorAll('.most-sold__slider-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.most-sold__track');
    var prev  = wrap.querySelector('.ms-btn--prev');
    var next  = wrap.querySelector('.ms-btn--next');
    if (!track) return;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -200, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left:  200, behavior: 'smooth' }); });
  });

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.faq__item');
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq__item.is-open').forEach(function (el) { el.classList.remove('is-open'); });
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* ── Product media thumbnails ── */
  document.querySelectorAll('.product-media__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src  = thumb.dataset.src;
      var main = document.querySelector('.product-media__main img');
      if (main && src) main.src = src;
      document.querySelectorAll('.product-media__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ── Product tabs ── */
  document.querySelectorAll('.product-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      var page   = btn.closest('.product-page') || document;
      page.querySelectorAll('.product-tab-btn').forEach(function (b) { b.classList.remove('is-active'); });
      page.querySelectorAll('.product-tab-content').forEach(function (c) { c.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var content = page.querySelector('[data-tab-content="' + target + '"]');
      if (content) content.classList.add('is-active');
    });
  });

  /* ── Qty buttons (página de produto e carrinho) ──
     NOTA: cart-drawer.js gerencia os qty do drawer separadamente. */
  document.querySelectorAll('.product-form__qty').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value) || 1;
        if (btn.dataset.action === 'minus') input.value = Math.max(1, val - 1);
        else input.value = val + 1;
      });
    });
  });

  /* ── Testimonials slider ── */
  document.querySelectorAll('.testimonials-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.tsl-track');
    var prev  = wrap.querySelector('.tsl-prev');
    var next  = wrap.querySelector('.tsl-next');
    if (!track) return;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -300, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left:  300, behavior: 'smooth' }); });
  });

});

/* ── Mobile search toggle (fora do DOMContentLoaded para garantir execução) ──
   NOTA: header.liquid também registra esse mesmo listener internamente.
   Mantido aqui por segurança (idempotente — toggle de classe não duplica
   efeito, só adiciona/remove a mesma classe duas vezes seguidas, o que
   é inofensivo). Se quiser remover a duplicação completamente no futuro,
   pode apagar este bloco com segurança, já que header.liquid já cobre. */
document.addEventListener('DOMContentLoaded', function () {
  var searchToggleMobile = document.getElementById('search-toggle-mobile');
  var searchMobileEl     = document.getElementById('header-search-mobile');
  if (searchToggleMobile && searchMobileEl) {
    searchToggleMobile.addEventListener('click', function () {
      searchMobileEl.classList.toggle('is-open');
      if (searchMobileEl.classList.contains('is-open')) {
        var inp = searchMobileEl.querySelector('input');
        if (inp) inp.focus();
      }
    });
  }
});

/* ── Filter drawer da PLP ── */
(function () {
  'use strict';

  var openBtn  = document.getElementById('filter-drawer-open');
  var closeBtn = document.getElementById('filter-drawer-close');
  var drawer   = document.getElementById('filter-drawer');
  var overlay  = document.getElementById('filter-overlay');

  if (!openBtn || !drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) { overlay.style.display = 'block'; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) {
      overlay.classList.remove('is-visible');
      overlay.addEventListener('transitionend', function () { overlay.style.display = 'none'; }, { once: true });
    }
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  var mq = window.matchMedia('(min-width: 769px)');
  mq.addEventListener('change', function (e) {
    if (e.matches && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.querySelectorAll('.pagination__btn[href]').forEach(function (link) {
    link.addEventListener('click', function () {
      setTimeout(function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 50);
    });
  });

})();